module.exports = __webpack_public_path__ + "img/bg-best.b22aa817.png";